export function formatDuration(ms: number): string {
  const minutes = Math.round(ms / 60000);
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remaining = minutes % 60;
    return remaining > 0 ? `${hours}h ${remaining}min` : `${hours}h`;
  }
  return `${minutes} min`;
}

export function formatTime(timestampMs: number, timezone: string): string {
  return new Date(timestampMs).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
  });
}

export function formatDateTime(timestampMs: number, timezone: string): string {
  return new Date(timestampMs).toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
  });
}

// e.g. "https://meetings.hubspot.com/andres-hald/heidi-demo" → "andres-hald/heidi-demo"
export function extractMeetingSlug(meetingUrl: string): string | null {
  try {
    const url = new URL(meetingUrl);
    const path = url.pathname.replace(/^\/+|\/+$/g, '');
    return path || null;
  } catch {
    return null;
  }
}

// Centralised so the booker query and the fallback resolver derive identical
// query keys — TanStack Query dedupes on key equality.
export function getUserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
